import { AppLifecycleAdapter } from '@shared/adapters/app-lifecycle-adapter';

export class RendererAppLifecycle implements AppLifecycleAdapter {
  public onAppActive(callback: () => void): () => void {
    const visibilityHandler = () => {
      if (document.visibilityState === 'visible') {
        console.log('[RENDERER-APP-LIFECYCLE] visibilitychange -> visible');
        callback();
      }
    };

    const focusHandler = () => {
      console.log('[RENDERER-APP-LIFECYCLE] window focus');
      callback();
    };

    const onlineHandler = () => {
      console.log('[RENDERER-APP-LIFECYCLE] window online');
      callback();
    };

    document.addEventListener('visibilitychange', visibilityHandler);
    window.addEventListener('focus', focusHandler);
    window.addEventListener('online', onlineHandler);

    console.log('[RENDERER-APP-LIFECYCLE] Registered lifecycle listeners (visibilitychange, focus, online)');

    return () => {
      document.removeEventListener('visibilitychange', visibilityHandler);
      window.removeEventListener('focus', focusHandler);
      window.removeEventListener('online', onlineHandler);
      console.log('[RENDERER-APP-LIFECYCLE] Removed lifecycle listeners');
    };
  }
}
